// extracted by mini-css-extract-plugin
export default {"content":"communication_content__sXsn5"};